/**
 * Stable codes the "change access period" endpoint returns with a 409, so the
 * admin panel can tell the trainer WHY the change was refused instead of the
 * generic "contact support" (TRE-2048: a `past_due` installment plan looked
 * like an outage).
 */
export const ExtendAccessErrorCode = {
  /** The Stripe subscription is not in a state that may be extended (`past_due`, `canceled`, …). */
  SubscriptionNotActive: "subscription_not_active",
  /** The requested change is not supported for this plan shape. */
  Unsupported: "unsupported",
} as const;

export type ExtendAccessErrorCode = (typeof ExtendAccessErrorCode)[keyof typeof ExtendAccessErrorCode];

/** The 409 body of `/extend-client-access-period`. */
export type ExtendAccessErrorBody = {
  message: string;
  code: ExtendAccessErrorCode;
  /** Set with `SubscriptionNotActive`: the Stripe status that blocked the change. */
  subscriptionStatus?: string;
};
